<!--
 * @Author: your name
 * @Date: 2020-12-11 11:17:01
 * @LastEditTime: 2022-09-28 15:02:58
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-admin/tab-order/index.vue
-->
<style lang="sass" scoped>
.footer_common
  position: fixed
  bottom: 0
  left: 0

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)
</style>

<style scoped lang="sass">
.container
  display: flex
  align-items: center
  padding-top: 42px

.img_container
  height: 58px
  width: 58px

.img
  height: 100%
  width: 100%
  margin: auto

.title
  margin-top: 12px
  margin-bottom: 40px
  line-height: 1
  font-size: 19px

.sub_title
  line-height: 15px
  font-size: 13px

.price
  margin-top: 10px
  margin-bottom: 40px
  line-height: 35px
  font-size: 29px

.email
  display: flex
  flex-direction: column
  align-items: center
  line-height: 15px
  font-size: 13px
  text-align: center

</style>

<template lang="pug">
.container
  .img_container
    img.img(:src="successIcon")
  .title.b {{ title }}
  .sub_title {{ subTitle }}
  .price {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ price }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
  .email
    span.text We have emailed a tax receipt to you at
    span.address.b {{ email }}
  footer-common.footer_common.b(
    :text="text"
    @clickButton="handleSubmit"
  )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapState } from 'vuex'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'

@Component({
  created() {
    this.$store.commit('closeLoading')
  },

  props: {
    venueId: {
      type: String
    },

    tabId: {
      type: [String, Number]
    }
  },

  computed: {
    ...mapState({
      routerInfo: state => state.venueHome.routerInfo
    }),
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  }
})

class TabOrder extends Vue {
  subTitle = 'You have been charged:'
  title = 'Your tab is now closed'
  successIcon = require('@/assets/tab-pics/success-icon.png')
  text = 'GO TO MENU'

  get price() {
    return formatDecimalNumber(parseFloat(this.$route.query.price))
  }

  get email() {
    return this.$route.query.email
  }

  handleSubmit() {
    this.jumpToMenu()
  }

  jumpToMenu() {
    const tableNumber = this.routerInfo.number || this.$route.query?.tableNumber
    if (tableNumber) {
      this.$router.push(`/v/${this.venueId}/home/t/${tableNumber}`)
    } else {
      this.$router.push(`/v/${this.venueId}/home/p/`)
    }
  }
}

export default TabOrder
</script>
